import { createAsyncThunk } from '@reduxjs/toolkit';

import { show } from 'src/common/primitives/Toast/toast.slice';
export const execTripMenuAction = createAsyncThunk(
  'dispatcher/trip-menu/exec-action',
  async function execTripMenuActionImpl(
    {
      action,
      successMessage,
      errorMessage,
      serverErrorMessageFormatter,
    }: {
      action: () => Promise<void>;
      successMessage: string;
      errorMessage: string | null;
      serverErrorMessageFormatter?: (error: any) => string | null;
      // Board trips this action changes; they render dimmed while the action
      // (and the refetch reflecting it) settles. Read by dispatcher.slice
      // from meta.arg — not used in the thunk body.
      tripIds?: string[];
    },
    { dispatch }
  ) {
    try {
      await action();
      dispatch(
        show({
          description: successMessage,
          type: 'success',
        })
      );
    } catch (e) {
      // TODO: provide an onError hook to allow showing errors in modals
      const serverErrorMessage =
        (serverErrorMessageFormatter && serverErrorMessageFormatter(e)) || null;

      if (serverErrorMessage) {
        dispatch(
          show({
            description: serverErrorMessage,
            type: 'error',
          })
        );
      } else if (errorMessage) {
        dispatch(
          show({
            description: errorMessage,
            type: 'error',
          })
        );
      }

      // Reject the thunk so the slice's error terminals actually fire
      // (ending the in-flight trip ghost and any pending drag) — otherwise
      // failures fulfill and the ghost lingers until the next board fetch.
      // Callers dispatch without unwrap(), so nothing throws upstream.
      throw e;
    }
  }
);
